var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderOrderMain',{attrs:{"header":"รายละเอียดใบสินค้าเข้าจากโรงงาน (In coming information)","img_header":_vm.img_holder,"link_back":"ordermain/incomingcompany"}}),_c('Order_incoming_detail_company')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }